"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
require("../styles/VsPumpSetupComponent.css");
var _EditWaterDestinationComponent = _interopRequireDefault(require("./EditWaterDestinationComponent"));
var _SuccessModal = _interopRequireDefault(require("./SuccessModal"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
const VsPumpSetupComponent = _ref => {
  let {
    totalPage,
    currentPage,
    navHeading,
    rightNavHeading,
    headerText,
    handleCancle,
    handleBack,
    pumpSetupContent,
    aboutWaterContent,
    pumpSetupBottomContent,
    saveContinueBtnTitle,
    saveContinueBtnClick,
    saveContinueBtnDisabled,
    openWaterModal,
    positiveActionButtonTitle,
    modalHeaderText,
    learnMoreText,
    handleWaterModal,
    selectedItems,
    items,
    handleCheckBoxSelection,
    shouldCheckBoxDisabled,
    imageData,
    showSuccessModal,
    handleSuccessModal,
    successModalBtnTitle,
    successModalData,
    isUpdating,
    modelNumber,
    isAccessoryPresent
  } = _ref;
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _images.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "PageCount",
    style: {
      paddingLeft: 22,
      paddingTop: 15,
      fontFamily: "poppins",
      fontSize: 18
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), " of ", totalPage), /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_EditWaterDestinationComponent.default, {
    modelNumber: modelNumber,
    headerText: headerText,
    pumpSetupContent: pumpSetupContent,
    handleWaterModal: handleWaterModal,
    openWaterModal: openWaterModal,
    aboutWaterContent: aboutWaterContent,
    items: items,
    selectedItems: selectedItems,
    handleCheckBoxSelection: handleCheckBoxSelection,
    pumpSetupBottomContent: pumpSetupBottomContent,
    saveContinueBtnClick: saveContinueBtnClick,
    saveContinueBtnTitle: saveContinueBtnTitle,
    saveContinueBtnDisabled: saveContinueBtnDisabled,
    shouldCheckBoxDisabled: shouldCheckBoxDisabled,
    modalHeaderText: modalHeaderText,
    positiveActionButtonTitle: positiveActionButtonTitle,
    learnMoreText: learnMoreText,
    imageData: imageData
  }), showSuccessModal ? /*#__PURE__*/_react.default.createElement(_SuccessModal.default, {
    handleSuccessModal: handleSuccessModal,
    showSuccessModal: showSuccessModal,
    successModalBtnTitle: successModalBtnTitle,
    successModaldata: successModalData,
    isAccessoryPresent: isAccessoryPresent
  }) : ""));
};
var _default = exports.default = VsPumpSetupComponent;